/* eslint-disable no-console */
export const trace = !import.meta.env.PROD ? (...args: any) => console.log('[src/index]', ...args) : () => {};
